document.addEventListener('DOMContentLoaded', function() {
  var close_popup = document.querySelector(".email-popup img.close");
  var email_popup = document.querySelector(".email-popup");
  const buttons = document.querySelectorAll('a.button.button--secondary.button--fixed.button--md.icon-with-text');
    
    // Loop through each button
    buttons.forEach(button => {
        // Check if the button contains the text "Sign up for updates"
        const buttonText = button.querySelector('.btn-text').textContent.trim();
        if (buttonText === 'Sign up for updates') {
            // Add a click event listener to the button
            button.addEventListener('click', function(event) {
                event.preventDefault(); // Prevent default action if needed
                /*email_popup.style.display="block";*/

                /*OPEN KLAVIYO FORM*/
                window._klOnsite = window._klOnsite || [];
                window._klOnsite.push(['openForm', 'XKTm3s']);
            });
        }
    });
  
  close_popup.addEventListener("click",function(){
    email_popup.style.display="none";
    
  });
});                         